export default __webpack_public_path__ + "static/media/projectplaceholder.85300a16.jpg";